/**
 * The data scheme for the response from Content API
 *
 * @export
 * @interface ContentAPIResponse
 */

export interface ContentAPIResponse {
  id: string
  culture: string
  route: string
  beginDate?: Date
  endDate?: Date
  title: string
  head: string
  content: string
  contentSections: string[]
  keywords: string
  description: string
  breadcrumbs: string[]
}

export interface ContentState {
  pageData: {
    [id: string]: ContentAPIResponse;
  }
}

export interface ContentPair {
  key: string
  pageData: ContentAPIResponse
}

export enum ContentPath {
  HOME = 'homepage',
  CATEGORY = 'categories',
  FOOTER = 'footer',
  NAVIGATION = 'navigation',
  COLLECTIONS = 'demo/homepage/collections',
  RELEASES = 'demo/homepage/releases',
  PRODUCT404 = 'product404',
  PPSOLDOUT = 'pp-sold-out'
}
